import './index.scss';
import ReactDOM from 'react-dom/client';
import Root from './root';

ReactDOM.createRoot(document.getElementById('root')!).render(<Root />);
